import BaseComponent from './basecomponent';
import 'jquery';
import {Size, Point} from './core/utils';


export default class Map extends BaseComponent {
    static get DEFAULTS() {
        return {
            marker: {                               // Opzioni del marker
                enabled: true,                      // Abilitato o no (bool)
                position: null,                     // Posizione (Map.Coordinates o null per mostrarlo al centro della mappa)
                title: null,                        // Titolo del marker (string)
                image: null,                        // Percorso o URL all'immagine del marker (string)
                imageSize: new Size(33, 48),        // Dimensione dell'immagine (utils.Size)
                imagePoint: new Point(0, 0),        // Posizione dell'immagine (utils.Point)
                infoWindowContent: null             // Contenuto della infoWindow del marker (string)
            },
            geolocation: {                          // Opzioni di geolocalizzazione
                enabled: false,                     // Abilitata o no (bool)
                infoWindowContent: null             // Contenuto della infoWindow del marker della posizione dell'utente (string)
            },
            autoresize: {                           // Opzioni di autoridimensionamento della mappa
                enabled: false,                     // Abilitata o no (bool)
                heightRatio: 0.5                    // Rapporto altezza mappa rispetto altezza pagina (float da 0 a 1)
            },
            mapStyle: null                          // Stile della mappa (object)
        }
    }

    /**
     * Constructor dell'oggetto Map
     *
     * @param containerId Id del contenitore della mappa.
     * @param center Coordinate in cui centrare la mappa e visualizzare, opzionalmente, il marker.
     * @param options Altre opzioni. Vedi Map.DEFAULTS per le opzioni predefinite.
     * @param mapOptionsCustomizer Un callback con signature "(mapOptions) => mapOptions" per personalizzare le opzioni della mappa google (default null)
     */
    constructor(containerId, center, options, mapOptionsCustomizer = null) {
        super();

        this.map = null;
        this.containerId = containerId;
        this.center = center;
        this.options = $.extend(true, {}, Map.DEFAULTS, options);
        this.mapOptions = {};
        this.mapOptionsCustomizer = mapOptionsCustomizer;


    }

    /**
     * Renderizza la mappa
     */
    render() {
        this.mapContainer = document.getElementById(this.containerId);
        this.mapOptions = this._buildMapOptions();
        this.map = new google.maps.Map(this.mapContainer, this.mapOptions);

        // Show marker if enabled
        if (this.options.marker.enabled) {
            this._initMarker();
        }

        // Setup geolocation if enabled
        if (this.options.geolocation.enabled) {
            this._initGeolocation();
        }

        // Setup autoresize
        if (this.options.autoresize.enabled) {
            if (this.options.autoresize.heightRatio < 0) this.options.autoresize.heightRatio = 0;
            if (this.options.autoresize.heightRatio > 1) this.options.autoresize.heightRatio = 1;
            this._initAutoresize();
        }
    }

    /**
     * Costruisce l'oggetto con le opzioni di configurazione della mappa
     *
     * @returns object Restituisce l'oggetto di configurazione
     * @private
     */
    _buildMapOptions() {
        var opts = {
            panControl: true,
            panControlOptions: {
                position: google.maps.ControlPosition.LEFT_CENTER
            },
            zoom: 13,
            zoomControl: true,
            zoomControlOptions: {
                style: google.maps.ZoomControlStyle.LARGE,
                position: google.maps.ControlPosition.RIGHT_CENTER
            },
            center: new google.maps.LatLng(this.center.lat, this.center.lng),
            scrollwheel:false,
            mapTypeControl: false,
            mapTypeControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM
            },
            streetViewControl: true,
            streetViewControlOptions: {
                position: google.maps.ControlPosition.RIGHT_CENTER
            },
            styles: this.options.mapStyle
        };

        // Chiamo il callback per personalizzare le opzioni mappa
        if (typeof this.mapOptionsCustomizer === 'function') {
            opts = this.mapOptionsCustomizer(opts);
        }

        return opts;
    }

    /**
     * Imposta il marker
     *
     * @private
     */
    _initMarker() {
        // Marker options
        var markerPosition = this.options.marker.position,
            markerSize = this.options.marker.imageSize,
            markerPoint = this.options.marker.imagePoint;


        var image = null;
        if (this.options.marker.image) {
            image = new google.maps.MarkerImage(this.options.marker.image,
                new google.maps.Size(markerSize.w, markerSize.h),
                new google.maps.Point(markerPoint.x, markerPoint.y));
        }

        if (!markerPosition) {
            markerPosition = this.mapOptions.center;
        }else {
            markerPosition = new google.maps.LatLng(markerPosition.lat, markerPosition.lng);
        }

        // Marker init
        var marker = new google.maps.Marker({
            map: this.map,
            position: markerPosition,
            icon: image,
            title: this.options.marker.title
        });

        // Info window
        if (this.options.marker.infoWindowContent) {
            var infowindow = new google.maps.InfoWindow({
                content: this.options.marker.infoWindowContent
            });

            google.maps.event.addListener(marker, 'click', () => {
                infowindow.open(this.map, marker);
            });
        }
    }

    /**
     * Imposta la geolocalizzazione
     *
     * @private
     */
    _initGeolocation() {
        this.geolocation = new Map.GeolocationService(
            this.map,
            this.mapOptions.center,
            this.options.geolocation.infoWindowContent);
        this.geolocation.start();
    }

    /**
     * Imposta l'autoresize della mappa
     * @private
     */
    _initAutoresize() {
        var $map = $(this.mapContainer),
            $window = $(window),
            heightRatio = this.options.autoresize.heightRatio;

        $window.resize(() => {
            var windowHeight = $window.outerHeight();
            var height = windowHeight * heightRatio;

            $map.css('height', height);
        }).trigger('resize');
    }
}

Map.Coordinates = class {
    constructor(latitude, longitude) {
        this.latitude = latitude;
        this.longitude = longitude;
    }

    get lat() {
        return this.latitude;
    }

    get lng() {
        return this.longitude;
    }
};

Map.GeolocationService = class {
    /**
     * Constructor del servizio di geolocation
     *
     * @param map Map instance
     * @param destination Destination coordinates
     * @param infoWindowContent Text
     */
    constructor(map, destination, infoWindowContent) {
        this.map = map;
        this.destination = destination;
        this.infoWindowContent = infoWindowContent;

        this.directionsService = new google.maps.DirectionsService();
        this.directionsDisplay = new google.maps.DirectionsRenderer();
        this.directionsDisplay.setMap(this.map);
    }

    /**
     * Avvia la geolocalizzazione dell'utente e il calcolo del percorso
     */
    start() {
        // Try HTML5 geolocation
        if(navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                // No errors
                this._showUserPositionMarker(position);
            }, () => {
                // Geolocation Error
                this._handleNoGeolocation(true);
            });
        }else {
            // Browser doesn't support Geolocation
            this._handleNoGeolocation(false);
        }
    }

    /**
     * Mostra il marker nella posizione corrente dell'utente
     * @param position
     * @private
     */
    _showUserPositionMarker(position) {
        var pos = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);

        var infoWindow = new google.maps.InfoWindow({
            map: this.map,
            position: pos,
            content: this.infoWindowContent
        });

        this.map.setCenter(pos);

        this._calcRoute(pos);
    }

    /**
     * Calcola il percorso dalla posizione dell'utente alla destinazione indicata nel constructor.
     *
     * @param startPosition La posizione iniziale da cui calcolare il percorso
     * @private
     */
    _calcRoute(startPosition) {
        var request = {
            origin: startPosition,
            destination: this.destination,
            travelMode: google.maps.TravelMode.DRIVING
        };

        this.directionsService.route(request, (response, status) => {
            if (status == google.maps.DirectionsStatus.OK) {
                this.directionsDisplay.setDirections(response);
            }
        });
    }

    /**
     * Gestisce eventuali errori nel calcolo della posizione dell'utente o del percorso.
     * @param errorFlag
     * @private
     */
    _handleNoGeolocation(errorFlag) {
        var content;
        if (errorFlag) {
            content = 'Error: The Geolocation service failed.';
        }
        else {
            content = 'Error: Your browser doesn\'t support geolocation.';
        }

        console.log(content);
    }
};


/** WEBPACK FOOTER **
 ** ./assets/scripts/src/map.js
 **/